export default __webpack_public_path__ + "static/media/poster 2.8f391825.png";